import { projectsConstants } from "@/constants";
import type { ProjectInterface, UpdateProjectPayloadInterface } from "@/interfaces";
import { projectsService } from "@/services";

import { useMutationAction, invalidateSessionCachedList, type FieldErrors } from "../shared";

export const useUpdateProject = ({ onFieldErrors }: { onFieldErrors?: (e: FieldErrors) => void } = {}) => {
    const { mutate, isLoading } = useMutationAction(
        async (id: string, payload: UpdateProjectPayloadInterface): Promise<ProjectInterface> => {
            const res = await projectsService.updateHandler(id, payload);
            invalidateSessionCachedList("projects.lite");
            return res;
        },
        {
            successMessage: projectsConstants.messages.updateSuccess,
            errorFallback: projectsConstants.errors.updateFailed,
            onFieldErrors,
            context: "projects.update",
        },
    );

    return { updateHandler: mutate, isLoading };
};
